module.exports = __webpack_public_path__ + "catalog/items/simple-stair/textures/marble.jpg";